module.exports = __webpack_public_path__ + "static/media/add-logo-blue.7dc92802.svg";